import { render } from 'datocms-structured-text-to-plain-text';
import { StructuredText } from 'datocms-structured-text-utils';
import { isEmpty } from 'lodash';

const isStructuredTextEmpty = (field: StructuredText | undefined | null): boolean =>
  isEmpty(field) || isEmpty(render(field));

export { isStructuredTextEmpty };
